import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import logoImage from "../../assets/images/logo.svg";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

function OTPVerification() {
  const navigate = useNavigate();
  const location = useLocation();
  const [verification, setVerification] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setVerification(false);
  };

  // Handle OTP verification
  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setOtpError("");

    try {
      if (!otp) {
        setOtpError("Please Enter OTP");
        setIsLoading(false);
        return;
      }

      if (otp.length !== 4) {
        setOtpError("Please Enter 4-digit OTP");
        setIsLoading(false);
        return;
      }

      // Check if token exists from forgot password
      if (!location.state?.token) {
        toast.error("Session expired. Please request OTP again.");
        navigate("/forgot-password");
        setIsLoading(false);
        return;
      }

      const response = await handleApiCall(
        "post",
        `${endpoints.verifyOtp}`,
        {
          otp: otp,
        },
        location.state?.token
      );

      if (response?.data?.code === 200 || response?.data?.code === "200") {
        toast.success("OTP Verified Successfully.");
        // Get token from response for reset password
        const resetToken = response?.data?.data?.token || response?.data?.token || location.state?.token;
        navigate("/reset-password", {
          state: {
            resetPasswordToken: resetToken,
            email: location.state?.email,
          },
        });
      } else if (response?.response?.data) {
        const errorMsg = response?.response?.data?.errorMessage || response?.response?.data?.message || "Invalid OTP";
        toast.error(errorMsg);
        setOtpError(errorMsg);
      } else if (response?.error) {
        // Error already handled by handleApiCall
        console.error("OTP verification error:", response?.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/*?php include ('includes/head.php'); ?*/}
      <div className="container-scroller">
        <div className="container-fluid flex-column page-body-wrapper full-page-wrapper login-bg">
          <div className="row flex-grow">
            <div className="col-lg-6 loginRight mx-auto d-flex align-items-center flex-column justify-content-center text-white">
              <div className="d-flex flex-column auth-form-light text-left w-75 px-0">
                <div className="logo text-center mt-n2 mb-2 shadow-sm pb-4 border-bottom border-light">
                  <div className="my-2">
                    <img src={logoImage} alt="Logo" />
                  </div>
                </div>
                <h4 className="my-4 px-5 text-center">Please Enter the Verification Code Sent To Your Email Address</h4>
                <div className="px-5 pt-1">
                  <form onSubmit={handleOtpVerification}>
                    <div className="form-group mt-1 d-flex px-5">
                      <div className="px-2">
                        <input
                          type="text"
                          className="form-control transparent rounded-pill px-0 text-center otp"
                          style={{ height: "54px" }}
                          placeholder=""
                          value={otp[0] || ""}
                          onChange={(e) => {
                            const newOtp = otp.split("");
                            newOtp[0] = e.target.value;
                            setOtp(newOtp.join(""));
                            setOtpError("");
                          }}
                          maxLength={1}
                        />
                      </div>
                      <div className="px-2">
                        <input
                          type="text"
                          className="form-control transparent rounded-pill px-0 text-center otp"
                          style={{ height: "54px" }}
                          placeholder=""
                          value={otp[1] || ""}
                          onChange={(e) => {
                            const newOtp = otp.split("");
                            newOtp[1] = e.target.value;
                            setOtp(newOtp.join(""));
                            setOtpError("");
                          }}
                          maxLength={1}
                        />
                      </div>
                      <div className="px-2">
                        <input
                          type="text"
                          className="form-control transparent rounded-pill px-0 text-center otp"
                          style={{ height: "54px" }}
                          placeholder=""
                          value={otp[2] || ""}
                          onChange={(e) => {
                            const newOtp = otp.split("");
                            newOtp[2] = e.target.value;
                            setOtp(newOtp.join(""));
                            setOtpError("");
                          }}
                          maxLength={1}
                        />
                      </div>
                      <div className="px-2">
                        <input
                          type="text"
                          className="form-control transparent rounded-pill px-0 text-center otp"
                          placeholder=""
                          value={otp[3] || ""}
                          onChange={(e) => {
                            const newOtp = otp.split("");
                            newOtp[3] = e.target.value;
                            setOtp(newOtp.join(""));
                            setOtpError("");
                          }}
                          maxLength={1}
                        />
                      </div>
                    </div>

                    {/* Error message display */}
                    {otpError && (
                      <div className="px-5 mt-2">
                        <h6 className="text-start text-red-600 font-normal">{otpError}</h6>
                      </div>
                    )}

                    <div className="flex pt-1">
                      <button
                        type="submit"
                        className="w-100 h-100 d-block text-center btn-black border-0 py-3 mt-2 rounded-lg"
                        disabled={isLoading || otp.length !== 4}
                        style={{ opacity: isLoading || otp.length !== 4 ? 0.6 : 1 }}
                      >
                        {isLoading ? "Verifying..." : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
                {/* <center className="mt-4">
                  <Link to='/' className="text-[#4444cb]">Login</Link>
                </center> */}
              </div>
            </div>
          </div>
        </div>
        <Modal size="sm" centered show={verification} onHide={handleClose}>
          <Modal.Body className="p-0">
            <Link to="/" className="card common_box px-3 py-4 text-center text-stone-950 hover:text-stone-800">
              <p className="text-xl font-semibold mb-0">A verification link has been sent to your registered email ID</p>
            </Link>
          </Modal.Body>
        </Modal>
      </div>
      {/*?php include ('includes/footer-files.php'); ?*/}
      {/*?php include ('includes/footer.php'); ?*/}
    </>
  );
}

export default OTPVerification;
